
export const dateFormat = "MM/D/YY";
export const timeFormat = "h:mm a";
// export const dateFormat = "MMMM Do YYYY, h:mm a";
